import React from 'react';
import styled, { css } from 'styled-components';
import { YotpoTable,
    YotpoTableHeader,
    YotpoTableHeaderCell,
    YotpoTableCell,
    YotpoTableRow,
    YotpoTableActionsCell,
    YotpoSecondaryActionsMenu } from '@yotpo-common/react-b2b-components/table';
import { YotpoList } from '@yotpo-common/react-b2b-components/list';
import { YotpoListItem } from '@yotpo-common/react-b2b-components/list-item';
import { YotpoAlignment, YotpoPriority, YotpoStatus, YotpoTableCellSize, YotpoTableRowSize } from '@yotpo-common/react-b2b-components/enums';
import { YotpoButton } from '@yotpo-common/react-b2b-components/button';
import { YotpoIcon } from '@yotpo-common/react-b2b-components/icon';
import { YotpoBadge } from '@yotpo-common/react-b2b-components/badge';
import { NameCell } from './NameCell';
import { ChannelModal } from '../ChannelModal';
import { CarouselModal } from '../CarouselModal';
import { useState } from 'react';
import { texts } from '../../constants';

const Wrapper = styled.div`
    width: 1111px;
    /* width: 100%; */
    
    /* yotpo-table::part(columns) {
        border: 5px solid red;
    } */

    yotpo-table-cell::part(cell) {
        
        /* display: none !important; */
        /* .dummy-header-cell {
        }
        .table__wrapper {
            border: 5px solid red;
        } */
    }
`;

const tableColumns = ['Name', '', 'Channel', 'Status', ''];
const tableRecords = [
    {
        name: 'Yotpo Loyalty redemption reminder',
        preview: 'Preview',
        channel: 'Icons',
        status: 'Inactive',
    },
    {
        name: 'Yotpo Loyalty redemption reminder',
        preview: 'Preview',
        channel: 'Icons',
        status: 'Active',
    },
    {
        name: 'Yotpo Loyalty redemption reminder',
        preview: 'Preview',
        channel: 'Icons',
        status: 'Active',
    },
    {
        name: 'Yotpo Loyalty redemption reminder',
        preview: 'Preview',
        channel: 'Icons',
        status: 'Active',
    },
];

export const Table = () => {
    const [openChannelModal, setOpenChannelModal] = useState({});
    const [openCarouselModal, setOpenCarouselModal] = useState({});

    const handleCloseChannelModal = () => {
        setOpenChannelModal({})
    }

    const handleCloseCarousellModal = () => {
        setOpenCarouselModal({})
    }

    const handleOpenChannelModal = (id : any) => {
        setOpenChannelModal({
            open: true,
            id
        })
    }
    const handleOpenCarouselModal = (id : any) => {
        setOpenCarouselModal({
            open: true,
            id
        })
    }

    const handleMainAction = (rowIndex: number) => {
        setOpenChannelModal({
            open: true,
            id: rowIndex
        })
        console.log('Main Action was activated on row ', rowIndex);
    };

    const handleSecondaryActionSelected = (event: CustomEvent, rowIndex: number) => {
        console.log('Secondary Action ', event.detail.label, ' was selected on row ', rowIndex);
    };
    
    return (
        <Wrapper>
            <YotpoTable 
                hasActionsColumn={true} 
                rowSize={YotpoTableRowSize.large} 
            >
                {tableColumns.map((tableColumn, index) => {
                    if (index === 0) {
                        return (
                            <YotpoTableHeaderCell size={YotpoTableCellSize.stretch} key={index} slot="columns">
                                {tableColumn}
                            </YotpoTableHeaderCell>
                        )
                    } else if (index > 1 && index < 4) {
                        return (
                            <YotpoTableHeaderCell alignment={YotpoAlignment.center} size={YotpoTableCellSize.small} key={index} slot="columns">
                                {tableColumn}
                            </YotpoTableHeaderCell>
                        )   
                    }
                    else if (index === 4) {
                        return (
                            <YotpoTableHeaderCell alignment={YotpoAlignment.center} size={YotpoTableCellSize.tiny} key={index} slot="columns">
                                {tableColumn}
                            </YotpoTableHeaderCell>
                        )   
                    } 
                    
                })}

                {tableRecords.map((tableRecord, index) => (
                    <YotpoTableRow
                        key={`${index} - ${tableRecord.name}`}
                        onYotpoMainAction={() => handleMainAction(index)}
                    >
                        <YotpoTableCell 
                            alignment={YotpoAlignment.left} 
                            size={YotpoTableCellSize.stretch}
                        >
                            <NameCell />
                        </YotpoTableCell>

                        <YotpoTableCell 
                            alignment={YotpoAlignment.center} 
                            size={YotpoTableCellSize.small}
                        >
                            <YotpoButton priority={YotpoPriority.tertiary} onClick={() => handleOpenCarouselModal(index)}>{texts.TABLE.PREVIEW_BUTTON}</YotpoButton>
                        </YotpoTableCell>

                        <YotpoTableCell 
                            alignment={YotpoAlignment.center} 
                            size={YotpoTableCellSize.small}
                        >
                            <div style={{display: 'flex', justifyContent: 'space-between', width: '50px'}}>
                                <YotpoIcon style={{width: '17px', height: '17px', color: '#696f80'}} name="sms"></YotpoIcon>
                                <YotpoIcon style={{width: '17px', height: '17px', color: '#696f80'}} name="email"></YotpoIcon>
                            </div>
                        </YotpoTableCell>

                        <YotpoTableCell 
                            alignment={YotpoAlignment.center} 
                            size={YotpoTableCellSize.small}
                        >
                            <YotpoBadge priority={YotpoPriority.secondary} status={tableRecord.status === 'Active' ? YotpoStatus.success : YotpoStatus.warning}>{tableRecord.status}</YotpoBadge>
                        </YotpoTableCell>

                        <YotpoTableCell
                            alignment={YotpoAlignment.center} 
                            size={YotpoTableCellSize.tiny}
                        >

                        </YotpoTableCell>

                        <YotpoTableActionsCell 
                            mainActionLabel="Enable"
                        >
                            <YotpoSecondaryActionsMenu
                                onYotpoSelect={event => handleSecondaryActionSelected(event, index)}
                                slot="secondary-actions"
                            >
                                <YotpoList>
                                    <YotpoListItem label="Edit flow">
                                        <YotpoIcon style={{width: '15px', height: '15px'}} name="edit" slot='prefix'></YotpoIcon>
                                    </YotpoListItem>

                                    <YotpoListItem click={() => handleOpenChannelModal(index)} label="Change channel">
                                        <YotpoIcon style={{width: '15px', height: '15px'}} name="transfer" slot='prefix'></YotpoIcon>
                                    </YotpoListItem>

                                    <YotpoListItem label="Stop flow">
                                        <YotpoIcon style={{width: '15px', height: '15px'}} name="close-circle" slot='prefix'></YotpoIcon>
                                    </YotpoListItem>
                                </YotpoList>
                            </YotpoSecondaryActionsMenu>
                        </YotpoTableActionsCell>

                    </YotpoTableRow>
                ))}
            </YotpoTable>
            <ChannelModal openChannelModal={openChannelModal} handleOpenCarouselModal={handleOpenCarouselModal} onClose={handleCloseChannelModal}/>
            <CarouselModal openCarouselModal={openCarouselModal} onClose={handleCloseCarousellModal}/>
        </Wrapper>
    );

}